export default "__VITE_ASSET__WPdr$juG__"